import DestinationForm from './component';

export default DestinationForm;
